import React, {useContext} from "react";
import {TimelineFrameDataContext} from "../../../../TimelineFramePage";
import {TYPE_FIMLAB} from "../../../../../../definitions/TimelineItems";
import {FormattedMessage} from "react-intl";
import {getDepartmentDisplay} from "../../../../../../utils/TimelineUtils";

let { id: module_id } = module;
export const TimelineFrameContentFimlabDetails = () => {
    const { data } = useContext(TimelineFrameDataContext);

    if (data.type !== TYPE_FIMLAB) {
        return null;
    }

    return (
        <span className="notification-info">
              <FormattedMessage
                  id={`${module_id}.fimlab.details`}
                  values={{
                      organisationUnit: getDepartmentDisplay(data.organisationUnit)
                  }}
              />
            </span>
    )

}